export default [
    "24 24",
  '<path d="M9 18L15 12L9 6" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

